import React from 'react';
import { useTheme } from 'styled-components';
import {
  ActionBanner,
  GENERIC_PUSH_FRIEND_ERROR,
  PUSH_RESULT_NOTIFICATION,
  PushResultEvent,
  useOnMountUnsafe
} from '@make-software/tg-mini-app-ui';

import { FRIENDS_PATH } from '@/app/paths';
import {
  InviteFriendsModal,
} from '@/features'
import {
  Friend,
  LastContentRow,
  PageWrapper,
  useMe,
  // useSeasonInfo,
  useCollect,
  useFriends, telegramClientApi
} from '@/shared';
import GoldIcon from '@/shared/assets/icons/gold.svg';

import { NoFriends } from './components/no-friends';
import { StyledBodyText } from './styled';


// const computePushEndsOn = (friendId: string, airdropEndsOn: Date): Date | undefined => {
//   const now = new Date();
//   if (now >= airdropEndsOn) return new Date(0);
//
//   const pushedDateStr = localStorage.getItem(friendId);
//   if (pushedDateStr) {
//     const cooldownEnd = new Date(new Date(pushedDateStr).getTime() + 24 * 60 * 60 * 1000);
//     if (now < cooldownEnd) return cooldownEnd;
//   }
//   return undefined;
// };

export const Friends = () => {
  const theme = useTheme();
  const meService = useMe();
  // const airdropService = useSeasonInfo();
  const friendsService = useFriends();
  const { collect } = useCollect();
  const [inviteModalOpen, setInviteModalOpen] = React.useState<boolean>(false);
  const [, setPushedFriends] = React.useState<Map<string, Date>>(new Map());

  if (meService.error) return <div>{meService.error}</div>;

  const friends = friendsService.data?.friends || [];

  useOnMountUnsafe(async () => {
    await collect({ url: FRIENDS_PATH });
  });

  const handlePushFriend = async (id: string | number) => {
    const strId = id.toString();
    const pushedAt = new Date();
    setPushedFriends((prev) => new Map(prev).set(strId, pushedAt));

    const response = await telegramClientApi.pushFriend(strId);
    const payload: PushResultEvent = {
      message: '',
      error: ''
    };

    if (response.httpCode === 200) {
      payload.message = response.data.data.message;
      localStorage.setItem(strId, pushedAt.toString());
    } else {
      payload.error =
        response.httpCode == 400 ? response.error?.message : GENERIC_PUSH_FRIEND_ERROR;
      setPushedFriends((prev) => {
        const next = new Map(prev);
        next.delete(strId);
        return next;
      });
    }
    window.dispatchEvent(
      new CustomEvent<PushResultEvent>(PUSH_RESULT_NOTIFICATION, {
        detail: payload
      })
    );
  };

  const handleInviteClick = async () => {
    await collect({ button_clicked: 'invite_friend' });
    setInviteModalOpen(true);
  };

  const handleCloseModal = () => {
    setInviteModalOpen(false);
  };

  if (friends.length === 0) {
    return (
      <>
        <NoFriends onInvite={handleInviteClick} />
        <InviteFriendsModal
          isOpen={inviteModalOpen}
          onCloseModal={handleCloseModal}
          userId={meService.data?.user.id.toString() || ''}
        />
      </>
    );
  }

  return (
    <PageWrapper>
      <ActionBanner
        title="Get"
        subtitle="for invited friend"
        reward={parseInt(window.config.season_info.friendship_reward, 10)}
        iconSrc={GoldIcon}
        iconColor="#F1BF0B"
        buttonText="Invite"
        buttonProps={{
          width: 110,
          height: 36,
          borderRadius: '4px',
          padding: '8px 16px',
          fontFamily: theme.typography.fontFamily.sans
        }}
        onClick={handleInviteClick}
        background="linear-gradient(90deg, #8A4D50 0%, #212228 100%)"
      />
      <StyledBodyText weight={1} size={'lg'} color="#FFFFFF">
        My friends {friends.length && <span>{`(${friends.length} invited)`}</span>}
      </StyledBodyText>
      <LastContentRow gap={8} direction={'column'}>
        {friends.map((f, i) => {
          // const airdropEndsOn = new Date(
          //   airdropService.data?.airdrop.ends_on || '2099-01-01T00:00:00Z'
          // );
          // const pushedAt = pushedFriends.get(f.id);
          // const pushEndsOn = pushedAt
          //   ? new Date(pushedAt.getTime() + 24 * 60 * 60 * 1000)
          //   : computePushEndsOn(f.id, airdropEndsOn);
          return (
            <Friend
              key={f.id}
              index={i + 1}
              friend={f}
              onPushFriend={handlePushFriend}
              // pushEndsOn={pushEndsOn}
              // earnIconSrc={GoldIcon}
            />
          );
        })}
      </LastContentRow>
      <InviteFriendsModal
        isOpen={inviteModalOpen}
        onCloseModal={handleCloseModal}
        userId={meService.data?.user.id.toString() || ''}
      />
    </PageWrapper>
  );
};
